import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

export const contractStatusMap: Record<ContractStatus, MapItem> = {
  executed: { label: 'Executed' },
  in_progress: { label: 'In Progress' },
  not_started: { label: 'Not Started' },
}

export const contractStatusSchema = z.enum(Object.keys(contractStatusMap) as [ContractStatus, ...ContractStatus[]])

export type ContractStatus = 'executed' | 'in_progress' | 'not_started'
